import "./App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import React from "react";
import ErrorPage from "./components/fallbacks/ErrorPage";
import { TrackRequest } from "./components/TrackRequest";
import { ConfigProvider } from "antd";
import { AdminSettings } from "./components/admin/AdminSettings";
import Home from "./components/Home";
import { Category } from "./components/admin/Category";
import { Services } from "./components/admin/Services";
import { Forms } from "./components/admin/Forms";
import "react-quill/dist/quill.snow.css";
import "react-toastify/dist/ReactToastify.css";
import CredentialManagement from "./components/PortalCredentials/CredentialManagement";
import { Report } from "./components/user/Report";
import ErrorBoundary from "antd/es/alert/ErrorBoundary";
import { Layout } from "./layout/Layout";
import { ProtectedRoute } from "./routeWrapper/ProtectedRoute";
import { Optionslist } from "./components/admin/Optionslist";
import Portals from "./components/admin/portal/Portals";

import TwoFactor from "./components/TwoFactor";
import { Profile } from "./components/admin/Profile";
import { ChangeRole } from "./components/admin/ChangeRole";
import { ProfileAdminHome } from "./components/profileadmin/ProfileAdminHome";
import { TeamManagement } from "./components/admin/TeamManagement";
import { AssignCategoryToUser } from "./components/admin/AssignCategoryToUser";
import AdminPanelWrapper from "./components/admin/AdminPanelWrapper";
import { Adminhome } from "./components/admin/Adminhome";
import RoleWrapper from "./components/wrapper/RoleWrapper";
import PanelWrapper from "./components/wrapper/PanelWrapper";

function App() {
  const router = createBrowserRouter([

    {
      path: "/",
      element: <PanelWrapper />,
      children: [
        {
          path: "",
          element: (
            <ProtectedRoute
              element={
                <ErrorBoundary>
                    <Home />
                </ErrorBoundary>
              }
              allowedRoles={["customer"]}
            />
          ),
        },
        {
          path: "track-request",
          element: (
            <ProtectedRoute
              element={
                <ErrorBoundary>
                  <TrackRequest />
                </ErrorBoundary>
              }
              allowedRoles={["customer"]}
            />
          ),
        },
        {
          path: "portals",
          element: (
            <ProtectedRoute
              element={
                <ErrorBoundary>
                 <CredentialManagement />
                </ErrorBoundary>
              }
              allowedRoles={["customer"]}
            />
          ),
        },
        {
          path: "report",
          element: (
            <ProtectedRoute
              element={
                <ErrorBoundary>
                 <Report />
                </ErrorBoundary>
              }
              allowedRoles={["customer"]}
            />
          ),
        },
        {
          path: "team",
          element: (
            <ProtectedRoute
              element={
                <ErrorBoundary>
                 <TeamManagement />
                </ErrorBoundary>
              }
              allowedRoles={["customer"]}
            />
          ),
        },
      ],
    },
    // {
    //   path: "/",
    //   // element: <Intercom />,
    //   errorElement: <ErrorPage />,
    //   children: [
    //     {
    //       path: "",
    //       element: <PanelWrapper />,
    //       children: [
    //         {
    //           path: "",
    //           element: (
    //             <RoleWrapper>
    //               <Home />
    //             </RoleWrapper>
    //           ),
    //         },
    //         {
    //           path: "track-request",
    //           element: <TrackRequest />,
    //         },
    //         {
    //           path: "portals",
    //           element: <CredentialManagement />,
    //         },
    //         {
    //           path: "report",
    //           element: <Report />
    //         },
    //         { 
    //           path: "team" ,
    //           element: <TeamManagement/>,  
    //         } ,
    //         // {
    //         //   path: "admin",
    //         //   element: <AdminPanelWrapper />,
    //         //   children: [
    //         //     {
    //         //       path: "",
    //         //       element: <Adminhome />,
    //         //     },
    //         //     {
    //         //       path: "categories",
    //         //       element: <Category />,
    //         //     },
    //         //     {
    //         //       path: "profile",
    //         //       element: <Profile />,
    //         //     },
    //         //     {
    //         //       path: "assignCategory",
    //         //       element: <AssignCategoryToUser />,
    //         //     },
    //         //     {
    //         //       path: "role",
    //         //       element: <ChangeRole />,
    //         //     },
              
    //         //     {
    //         //       path: "services",
    //         //       element: <Services />,
    //         //     },
    //         //     {
    //         //       path: "forms",
    //         //       element: <Forms />,
    //         //     },
    //         //     {
    //         //       path: "settings",
    //         //       element: <AdminSettings />,
    //         //     },
    //         //     { 
    //         //       path: "manageTeam" ,
    //         //       element: <ProfileAdminHome /> 
    //         //     } ,
    //         //     { path: "portals", element: <Portals /> },
    //         //   ],
    //         // },

    //         // {
    //         //   path: "governifyProfileAdmin",
    //         //   element: <AdminPanelWrapper />,
    //         //   children: [
    //         //     {
    //         //       path: "",
    //         //       element: <ProfileAdminHome />,
    //         //     },
                
    //         //   ],
    //         // },
    //       ],
    //     },
    //   ],
    // },
    {
      path: "/admin",
      element: <PanelWrapper />,
      children: [
        {
          path: "",
          element: (
            <ProtectedRoute
              element={
                <ErrorBoundary>
                  <Optionslist />
                </ErrorBoundary>
              }
              allowedRoles={["superAdmin", "admin"]}
            />
          ),
        },

        {
          path: "categories",
          element: (
            <ProtectedRoute
              element={
                <ErrorBoundary>
                  <Category />
                </ErrorBoundary>
              }
              allowedRoles={["superAdmin", "admin"]}
            />
          ),
        },
        {
          path: "services",
          element: (
            <ProtectedRoute
              element={
                <ErrorBoundary>
                  <Services />
                </ErrorBoundary>
              }
              allowedRoles={["superAdmin", "admin"]}
            />
          ),
        },
        {
          path: "forms",
          element: (
            <ProtectedRoute
              element={
                <ErrorBoundary>
                 <Forms />
                </ErrorBoundary>
              }
              allowedRoles={["superAdmin", "admin"]}
            />
          ),
        },
        {
          path: "settings",
          element: (
            <ProtectedRoute
              element={
                <ErrorBoundary>
                  <AdminSettings />
                </ErrorBoundary>
              }
              allowedRoles={["superAdmin", "admin"]}
            />
          ),
        }, 
        {
          path: "profile",
          element: (
            <ProtectedRoute
              element={
                <ErrorBoundary>
                  <Profile />
                </ErrorBoundary>
              }
              allowedRoles={["superAdmin", "admin"]}
            />
          ),
        }, 
        {
          path: "role",
          element: (
            <ProtectedRoute
              element={
                <ErrorBoundary>
                  <ChangeRole />
                </ErrorBoundary>
              }
              allowedRoles={["superAdmin", "admin"]}
            />
          ),
        }, 
        { path: "portals", element: (
          <ProtectedRoute
            element={
              <ErrorBoundary>
                <Portals />
              </ErrorBoundary>
            }
            allowedRoles={["superAdmin", "admin"]}
          />
        ), },
      ],
    },
    { path: "*", element: <ErrorPage /> },
  ]);

  return (
    <ConfigProvider
      theme={{
        components: {
          Table: {
            headerBg: "#59C080",
            headerColor: "#fff",
          },
        },
      }}
    >
      <RouterProvider router={router} />
    </ConfigProvider>
  );
}

export default App;
